<template>
  <filter-summary
    icon="item"
    title="商品リスト"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ filename }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 商品リストの分析条件サマリ
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    filename: String,
    errors: {
      type: Array,
    },
  },
}
</script>
